import {
    Box,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import { DateTime } from "luxon";

import { SiteEvent } from "types/SiteEvent";

export interface SiteEventsContentProps {
    siteEvents: SiteEvent[];
}

export function SiteEventsContent(props: SiteEventsContentProps) {
    return (
        <Box width="100%">
            <Divider
                sx={{
                    marginBottom: 2,
                }}
            />
            <Typography
                variant="h6"
                sx={{
                    color: "text.primary",
                    textAlign: "center",
                }}
            >
                Site Events
            </Typography>
            <Table
                sx={{ minWidth: 650 }}
                aria-label="simple table"
            >
                <TableHead>
                    <TableRow>
                        <TableCell>Description</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell align="right">Start Date Time</TableCell>
                        <TableCell align="right">End Date Time</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.siteEvents.length > 0 ? (
                        props.siteEvents.map((siteEvent) => (
                            <TableRow key={`siteEvent' ${siteEvent.id}`}>
                                <TableCell>{siteEvent.description}</TableCell>
                                <TableCell>{siteEvent.eventType}</TableCell>
                                <TableCell align="right">
                                    {DateTime.fromISO(
                                        siteEvent.startDateTime,
                                    ).toLocaleString()}
                                </TableCell>
                                <TableCell align="right">
                                    {DateTime.fromISO(
                                        siteEvent.endDateTime,
                                    ).toLocaleString()}
                                </TableCell>
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell
                                colSpan={4}
                                align="center"
                            >
                                No data available
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </Box>
    );
}
